import { render, staticRenderFns } from "./GrupoContratoList.vue?vue&type=template&id=5ef5b118"
import script from "./GrupoContratoList.vue?vue&type=script&lang=js"
export * from "./GrupoContratoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports